import React, { useState, useEffect, useMemo, useCallback } from 'react';
import errorimage from '../../icon/noimage.png';
import './product.css';

// تابع برای بارگذاری تصاویر
const loadImage = (code) => {
    try {
        // return require(`../../../public/productimage/${code}.png`);
        // return require(`http://dl.mahoganyacademy.de/productimage/${code}.png`);
    } catch (error) {
        console.error('Error loading image:', error);
        return errorimage;
    }
};

const LazyImage = ({ src, alt, onLoad, onError }) => {
    const [hasError, setHasError] = useState(false);

    const handleError = useCallback(() => {
        setHasError(true);
        if (onError) onError();
    }, [onError]);

    return (
        <div className='productimage'>
            <img
                src={hasError ? errorimage : src}
                alt={alt}
                style={{ display: hasError ? 'none' : 'block' }}
                onError={handleError}
                onLoad={onLoad}
                loading='lazy'
            />
            {hasError && <div className='spinner'></div>}
        </div>
    );
};

export default function Productdata({ products, selectedBrand, errorget, showproductoflist, setShowproductoflist }) {
    const [displayedProducts, setDisplayedProducts] = useState([]);
    const [displayedCount, setDisplayedCount] = useState(6);
    const [loadingMore, setLoadingMore] = useState(false);

    const showproduct = useMemo(() => {
        return selectedBrand
            ? products.filter(product => product.brand === showproductoflist)
            : products;
    }, [products, selectedBrand, showproductoflist]);

    useEffect(() => {
        const productsToDisplay = showproduct.slice(0, displayedCount);
        setDisplayedProducts(productsToDisplay);
    }, [showproduct, displayedCount]);

    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 100 && !loadingMore) {
                setLoadingMore(true);
                setDisplayedCount(prevCount => prevCount + 6);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loadingMore]);

    useEffect(() => {
        if (loadingMore) {
            setLoadingMore(false);
        }
    }, [loadingMore]);

    return (
        <div className='productmain'>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <h2 style={{ textAlign: 'center', color: 'white' , textShadow: '1px 1px 5px black' }} onClick={() => setShowproductoflist('')}>
                    بازگشت به لیست برندها
                </h2>
            </div>

            <ul className='products'>
                <h1>{errorget}</h1>
                {displayedProducts.map(p => (
                    <li key={p.id}>
                        <div className='productbox'>
                            <LazyImage
                                src={p.name.includes('رنگ مو مایا فشن') ? require(`../../image/hairmaya.png`) : p.name.includes('کیت رنگ مو مایا') ? require(`../../image/hairmaya.png`) : p.name.includes('رنگ موی مکس مور') ? require(`../../image/hairmaxmoore.png`) : `http://dl.mahoganyacademy.de/productimage/${p.code}.png`}
                                alt={p.name}
                                onLoad={() => {}}
                                onError={() => {}}
                            />
                            <div className='productdetails'>
                                <h4>{p.name}</h4>
                                <p>برند: {p.brand}</p>
                                <p>مقدار: {p.description}</p>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>

            {loadingMore && (
                <div className='spinnerproduct'></div>
            )}
        </div>
    );
}
